import { render, staticRenderFns } from "./VaccinationData.vue?vue&type=template&id=0f4f39ef&scoped=true"
import script from "./VaccinationData.vue?vue&type=script&lang=ts"
export * from "./VaccinationData.vue?vue&type=script&lang=ts"
import style0 from "./VaccinationData.vue?vue&type=style&index=0&id=0f4f39ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f39ef",
  null
  
)

export default component.exports